import style_inject_es_default from "../../../../../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js";

//#region src/components/badge/badge.module.css
var css_248z = ".badge-module_root__0FL6h {\n    text-transform: none;\n}\n";
var badge_module_default = { "root": "badge-module_root__0FL6h" };
style_inject_es_default(css_248z);

//#endregion
export { badge_module_default as default };